import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-prix-moyen-graph',
    templateUrl: './prix-moyen-graph.component.html',
    styleUrls: ['./prix-moyen-graph.component.scss']
})
export class PrixMoyenGraphComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;
    user: User = Object.assign({}, EMPTY_USER);

    advice_price_choice = '';
    advice_price = 0;
    advice_price_L = 0;
    advice_price_U = 0;
    advice_price_cL = 0;

    secteur = '';
    iris = '';

    /**
     * Chart Loyer
     */
    priceChoice = {};
    options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: params => {
                var lib = '';

                if (params[0].name === 'Votre projet') {
                    let tot = 0;
                    params.forEach(d => {
                        if (d.seriesName == 'Travaux' || d.seriesName == 'Notaire' || d.seriesName == 'Votre projet') {
                            tot += Math.round(d.data);
                        }
                    });
                    lib += 'Votre projet : ' + Math.round(tot).toLocaleString('fr-FR') + ' €/m²<br/>';
                    params.forEach(d => {
                        if (d.seriesName == 'Travaux' || d.seriesName == 'Notaire' || d.seriesName == 'Votre projet') {
                            lib += ' • ' + (d.seriesName == 'Votre projet' ? 'Achat' : d.seriesName) + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' €/m²<br/>';
                        }
                    });
                } else {
                    params.forEach(d => {
                        if (d.seriesName != '' && d.seriesName != 'Travaux' && d.seriesName != 'Notaire' && d.seriesName != 'Votre projet' && d.data > 0) {
                            lib += d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' €/m²<br/>';
                        }
                    });
                }
                return lib;
            }
        },
        legend: {
            show: true,
            orient: 'vertical',
            right: '0px',
            top: '15px',
            align: 'right',
            data: []
        },
        grid: {
            left: '0%',
            right: '4%',
            top: '40px',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: []
        },
        color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],
        series: []
    };
    data = null;

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }

        if (this.advice_price_choice != "city.prix_commune.P"
            && this.advice_price_choice != "city.prix_commune.I"
        ) {
            this.advice_price_choice = this.advice_price_choice.replace('_gq', '');
            this.advice_price_choice = this.advice_price_choice.replace('_iris', '');
            if (this.iris.length == 7) {
                let s = this.advice_price_choice.split('.');
                this.advice_price_choice = s[0] + '.' + s[1] + '_gq.' + s[2];
            } else if (this.iris.length > 7) {
                let s = this.advice_price_choice.split('.');
                this.advice_price_choice = s[0] + '.' + s[1] + '_iris.' + s[2];
            }
        }

        // No emit to not save this modification
        let p = this.cityService.getPriceValue(this.favorite.ad_city, this.advice_price_choice, this.iris);
        if (p) {
            this.advice_price = p.pM;
            this.advice_price_L = p.q25;
            this.advice_price_U = p.q75;
            this.advice_price_cL = p.cL;
        }

        this.setData();
    }

    initData() {
        this.iris = this.favorite.iris;
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
        }
        this.advice_price_choice = this.favorite.advice_price_real;

        if (this.advice_price_choice == 'city.prix_commune.I') {
            this.advice_price_choice = 'city.prix_commune.A';
        }
        this.advice_price = this.favorite.advice_price;
        this.advice_price_L = this.favorite.advice_price_L;
        this.advice_price_U = this.favorite.advice_price_U;
        this.advice_price_cL = this.favorite.advice_price_cL;

        this.edit(null);
    }

    ngOnInit() {
        this.initData();
        this.extChange.subscribe(data => {
            this.initData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        this.priceChoice = this.cityService.getPriceChoice(this.favorite.ad_city, this.iris);
        delete (this.priceChoice['Général']['city.prix_commune.I']);
        delete (this.priceChoice['Général']['city.prix_commune_gq.I']);
        delete (this.priceChoice['Général']['city.prix_commune_iris.I']);

        this.options.legend.data = ['Appartement à ' + this.favorite.ad_city.name, 'Maison à ' + this.favorite.ad_city.name];
        this.options.yAxis.data = ['Tout confondu', (this.deviceService.isMobile() ? '1 pièce' : '1 pièce / Studio'), '2 pièces', '3 pièces', '4 pièces', '5 pièces'];

        this.data = {
            series: [
                {
                    name: 'Appartement à ' + this.favorite.ad_city.name,
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune.A ? this.favorite.ad_city.prix_commune.A.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[1] ? this.favorite.ad_city.prix_commune_nb_piece.A[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[2] ? this.favorite.ad_city.prix_commune_nb_piece.A[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[3] ? this.favorite.ad_city.prix_commune_nb_piece.A[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[4] ? this.favorite.ad_city.prix_commune_nb_piece.A[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.A && this.favorite.ad_city.prix_commune_nb_piece.A[5] ? this.favorite.ad_city.prix_commune_nb_piece.A[5].pM : null,
                        // 0,
                    ]
                },
                {
                    name: '',
                    type: 'bar',
                    data: [
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                    ]
                },
                {
                    name: 'Maison à ' + this.favorite.ad_city.name,
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune.M ? this.favorite.ad_city.prix_commune.M.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[1] ? this.favorite.ad_city.prix_commune_nb_piece.M[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[2] ? this.favorite.ad_city.prix_commune_nb_piece.M[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[3] ? this.favorite.ad_city.prix_commune_nb_piece.M[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[4] ? this.favorite.ad_city.prix_commune_nb_piece.M[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece.M && this.favorite.ad_city.prix_commune_nb_piece.M[5] ? this.favorite.ad_city.prix_commune_nb_piece.M[5].pM : null,
                        // 0,
                    ]
                },
                {
                    name: '',
                    type: 'bar',
                    data: [
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                    ]
                },
            ]
        };

        if (this.iris.length == 7 && this.favorite.ad_city.prix_commune_gq && this.favorite.ad_city.prix_commune_nb_piece_gq && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris]) {
            this.options.legend.data = [
                'Appartement à ' + this.favorite.ad_city.name,
                'Appartement du secteur "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                'Maison à ' + this.favorite.ad_city.name,
                'Maison du secteur "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"'];
            this.data.series = [
                this.data.series[0],
                {
                    name: 'Appartement du secteur "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune_gq[this.iris] && this.favorite.ad_city.prix_commune_gq[this.iris].A ? this.favorite.ad_city.prix_commune_gq[this.iris].A.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[1] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[2] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[3] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[4] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[5] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].A[5].pM : null,
                        // 0,
                    ]
                }, this.data.series[2], {
                    name: 'Maison du secteur "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune_gq[this.iris] && this.favorite.ad_city.prix_commune_gq[this.iris].M ? this.favorite.ad_city.prix_commune_gq[this.iris].M.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[1] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[2] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[3] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[4] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[5] ? this.favorite.ad_city.prix_commune_nb_piece_gq[this.iris].M[5].pM : null,
                        // 0,
                    ]
                }];
        }

        if (this.iris.length > 7 && this.favorite.ad_city.prix_commune_iris && this.favorite.ad_city.prix_commune_nb_piece_iris && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris]) {
            this.options.legend.data = [
                'Appartement à ' + this.favorite.ad_city.name,
                'Appartement du quartier "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                'Maison à ' + this.favorite.ad_city.name,
                'Maison du quartier "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"'];
            this.data.series = [
                this.data.series[0],
                {
                    name: 'Appartement du quartier "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune_iris[this.iris] && this.favorite.ad_city.prix_commune_iris[this.iris].A ? this.favorite.ad_city.prix_commune_iris[this.iris].A.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[1] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[2] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[3] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[4] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[5] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].A[5].pM : null,
                        // 0,
                    ]
                }, this.data.series[2], {
                    name: 'Maison du quartier "' + this.cityService.getQuartierName(this.advice_price_choice, this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        this.favorite.ad_city.prix_commune_iris[this.iris] && this.favorite.ad_city.prix_commune_iris[this.iris].M ? this.favorite.ad_city.prix_commune_iris[this.iris].M.pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[1] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[1].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[2] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[2].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[3] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[3].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[4] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[4].pM : null,
                        this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris] && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M && this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[5] ? this.favorite.ad_city.prix_commune_nb_piece_iris[this.iris].M[5].pM : null,
                        // 0,
                    ]
                }];
        }

        if (this.favorite.id !== '') {
            this.options.legend.data.push('Votre projet');
            this.options.yAxis.data.push('Votre projet');
            this.data.series.push({
                name: 'Votre projet',
                type: 'bar',
                stack: '1',
                data: [
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    (this.favorite.price / this.favorite.square).toPrecision(4),
                ]
            });
            this.data.series.push({
                name: 'Notaire',
                type: 'bar',
                stack: '1',
                data: [
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    (this.favorite.notary_price / this.favorite.square).toPrecision(4),
                ]
            });
            this.data.series.push({
                name: 'Travaux',
                type: 'bar',
                stack: '1',
                data: [
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    (this.favorite.works_total / this.favorite.square).toPrecision(4),
                ]
            });
        }

        if (this.deviceService.isMobile()) {
            this.options.grid.top = '35%';
            this.options.grid.right = '0px';
            this.options.legend.orient = 'horizontal';
            this.options.legend.right = 'auto';
            this.options.legend.align = 'auto';
        }

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
